import { Loader } from "@googlemaps/js-api-loader";

export default class GoogleMap {

	/** @var {String} #apiKey */
	#apiKey;

	/** @var {String} #themeDirectory */
	#themeDirectory;

	/** @var {HTMLElement} #mapElement */
	#mapElement;

	/**
	 * @param {HTMLElement} mapElement
	 */
	constructor(mapElement) {
		const apiKeyMetaTag = document.querySelector("meta[name='google-maps-api-key']");
		const themeDirectoryMetaTag = document.querySelector("meta[name='theme-directory']");
		if (!apiKeyMetaTag || !apiKeyMetaTag.content) {
			console.warn("Missing Google Maps API key.");
			return;
		}
		if (!themeDirectoryMetaTag || !themeDirectoryMetaTag.content) {
			console.warn("Missing theme directory meta tag.");
			return;
		}
		this.#apiKey = apiKeyMetaTag.content;
		this.#themeDirectory = themeDirectoryMetaTag.content;
		this.#mapElement = mapElement;
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					void this.#createMap();
					observer.unobserve(this.#mapElement);
				}
			});
		}, {
			root: null,
			rootMargin: '0px',
			threshold: 0.01,
		});
		observer.observe(this.#mapElement);
	}

	async #createMap() {
		const loader = new Loader({
			apiKey: this.#apiKey,
			version: 'weekly',
		});
		const { Map } = await loader.importLibrary("maps");
		const { Marker } = await loader.importLibrary("marker");
		const latitude = parseFloat(this.#mapElement.dataset.latitude);
		const longitude = parseFloat(this.#mapElement.dataset.longitude);
		const position = { lat: latitude, lng: longitude };
		const map = new Map(this.#mapElement, {
			zoom: 16,
			center: position,
			styles: [{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}],
			disableDefaultUI: true,
		});
		new Marker({
			position: position,
			map: map,
			icon: this.#themeDirectory + '/images/svg/pin.svg'
		});
	}

}
